'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = formlyFocus;

// @ngInject
function formlyFocus($timeout, $document) {
  return {
    restrict: 'A',
    link: function formlyFocusLink(scope, element, attrs) {
      var previousEl = null;
      var el = element[0];
      var doc = $document[0];
      attrs.$observe('formlyFocus', function respondToFocusExpressionChange(value) {
        /* eslint no-bitwise:0 */ // I know what I'm doing. I promise...
        if (value === 'true') {
          $timeout(function setElementFocus() {
            previousEl = doc.activeElement;
            el.focus();
          }, ~ ~attrs.focusWait);
        } else if (value === 'false') {
          if (doc.activeElement === el) {
            el.blur();
            if (attrs.hasOwnProperty('refocus') && previousEl) {
              previousEl.focus();
            }
          }
        }
      });
    }
  };
}
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./directives/formly-focus.js
 **/